import { render } from "./UiText.vue?vue&type=template&id=4d21e66c&ts=true"
import script from "./UiText.vue?vue&type=script&lang=ts"
export * from "./UiText.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ni/IdeaProjects/pioneer/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__